import { EpimsBaseEntityDto } from './epim-base.dto';
export class PaymentTypeDto extends EpimsBaseEntityDto {

    PaymentTypeId: string;

    PaymentTypeName: string;   

}